<template>
  <section class="detail_content">
    <div
      class="categoryList_card flx"
      v-if="subCategoryList.length > 0"
      v-for="(subCategory,index) in subCategoryList"
      :key="index"
    >
      <span class="img_wrapper spinner_wrapper" v-lazyload v-if="subCategory.bgImageURL">
        <ImageSpinner class="image_spinner" />
        <img :data-url="subCategory.bgImageURL" alt />
      </span>
      <div class="product_detail">
        <!-- <p>{{subCategory.name}}</p> -->
        <p v-if="subCategory.langData && subCategory.langData.hasOwnProperty(cookie)" @click="goToGetProductByCategory(subCategory.id,subCategory.langData[cookie],index)">{{subCategory.langData[cookie]}}</p>
        <p @click="goToGetProductByCategory(subCategory.id,subCategory.name,index)" v-else>{{subCategory.name}}</p>
      </div>
      <span class="go_detail_listing">
        <img src="../../assets/images/icons/right-arrow.png" alt style="height: 10px;" />
      </span>
    </div>
    <div  v-if="noRecordFound == true" class="no_record">
        <div class="page-status-panel">
          <div class="img-block">
            <img src="../../assets/images/icons/norecord.svg" alt />
          </div>
          <div class="details-block">
            <h2>No Records Found</h2>
            <p>There was no record found that will you enter here.</p>
          </div>
        </div>
      </div>
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </section>
</template>

<script>
import ImageSpinner from "../Common/ImageSpinner";
import VueCookie from "vue-cookie";
const cookie = VueCookie.get('lang')
export default {
  name: "SubCategoryListing",
  components: {
    ImageSpinner
  },
  data() {
    return {
      subCategoryList: [],
      loading: false,
      noRecordFound: false
    };
  },
  methods: {
    getAllCategories() {
      let payloadValue;
        if(this.$route.query.shopid){
          payloadValue = this.$route.params.subcategoryid + '?shopid=' + this.$route.query.shopid
        }else{
          payloadValue = this.$route.params.subcategoryid
        }
      this.loading = true;
      this.$store
        .dispatch({
          type: "getAllCategories",
          payload: payloadValue
        })
        .then(data => {
          this.loading = false;
          this.subCategoryList = data.data.childCategories;
          if (this.subCategoryList == null) {
            this.noRecordFound = true
          }
          this.$store.commit("saveCategoryList", {
            categoryList: this.subCategoryList
          });
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    goToGetProductByCategory(categoryId, name) {
      if(this.$route.query.from === 'LIFESTYLE'){
        if(this.$route.query.source === 'ADS_SERVER' && this.$route.query.campaignIdentifier){
          this.$router.push("/product-by-category?type=LIFESTYLE&categoryid=" + categoryId + '&parentCatId=' + this.$route.query.parentCatId + '&shopid=' + this.$route.query.shopid + '&source='+this.$route.query.source + '&campaignIdentifier=' + this.$route.query.campaignIdentifier);
        }else
        if(this.$route.query.shopid){
          this.$router.push("/product-by-category?type=LIFESTYLE&categoryid=" + categoryId + '&parentCatId=' + this.$route.query.parentCatId + '&shopid=' + this.$route.query.shopid );
        }else{
          this.$router.push("/product-by-category?type=LIFESTYLE&categoryid=" + categoryId + '&parentCatId=' + this.$route.query.parentCatId)
        }
      }else{
        if(this.$route.query.source === 'ADS_SERVER' && this.$route.query.campaignIdentifier){
          this.$router.push("/product-by-category?type=NORMAL&categoryid=" + categoryId + '&parentCatId=' + this.$route.query.parentCatId + '&shopid=' + this.$route.query.shopid + '&source='+this.$route.query.source + '&campaignIdentifier=' + this.$route.query.campaignIdentifier);
        }else
        if(this.$route.query.shopid){
          this.$router.push("/product-by-category?type=NORMAL&categoryid=" + categoryId + '&parentCatId=' + this.$route.query.parentCatId + '&shopid=' + this.$route.query.shopid );
        }else{
          this.$router.push("/product-by-category?type=NORMAL&categoryid=" + categoryId + '&parentCatId=' + this.$route.query.parentCatId)
        }
      }
      
       this.$store.commit("saveCategoryFilterData", {
        catfilterProdList: {}
      });
      this.$store.commit("saveCategoriesData", {
        categoriesProdList: [],
        categoriesPageIndex: 0
      });
    }
  },
  mounted() {
    this.getAllCategories();
    this.cookie = cookie
    // if(this.$store.getters.categoryList.length > 0){
    //   this.subCategoryList = this.$store.getters.categoryList
    // }else{
    //   this.getAllCategories()
    // }
  }
};
</script>
    